import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'

import { LOCALS } from './constants'
import { de, en, ru, uk } from './copies'

const resources = {
  [LOCALS.EN]: {
    translation: en,
  },
  [LOCALS.UK]: {
    translation: uk,
  },
  [LOCALS.DE]: {
    translation: de,
  },
  [LOCALS.RU]: {
    translation: ru,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language_code') || 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
